import React from 'react'
import { withTranslation } from 'react-i18next'
import Tile from 'srcReact/components/common2/Tile'
import styles from './styles.module.scss'

const TileSettingsComponent = ({ t, className, ...props }) => {
  const options = {
    types: ['optionTopLeft', 'optionTopRight', 'optionBottomLeft', 'optionBottomRight'],
    classes: {
      optionTopLeft: styles.optionTL,
      optionTopRight: styles.optionTR,
      optionBottomLeft: styles.optionBL,
      optionBottomRight: styles.optionBR
    }
  }

  return (
    <Tile className={`${className} ${styles.tileSetting} ${styles.tileComponent}`}>
      <div className={styles.tileOverlay}></div>
      {options.types.map((option, index) => {
        if (props[option]) {
          const { link, img, text } = props[option]
          return (
            <div key={'option_' + index} className={options.classes[option]}>
              <a {...(link.length > 0 && { href: link })} className={`a-full a-unstyle ${styles.link}`}>
                <img width='55%' className={styles.img} src={img ? img : ''} />
                <span className={styles.text}>{text}</span>
              </a>
            </div>
          )
        }
      })}
    </Tile>
  )
}

const ExtendedComponent = withTranslation('common')(TileSettingsComponent)
export { ExtendedComponent as TileSettingsComponent }
